import { useEffect, useState } from "react";
import { api } from "@/context/AuthContext";
import { fmtLuas } from "@/components/AreaView";
import { Card } from "@/components/ui/card";
import { Map, LandPlot, Trees, Building2, Home, ArrowRight } from "lucide-react";

export default function AreaSummaryCard({ onNavigate }) {
  const [areaStats, setAreaStats] = useState(null);

  useEffect(() => {
    api.get("/area/stats").then((res) => setAreaStats(res.data)).catch(() => {});
  }, []);

  return (
    <Card className="p-6 border-slate-200 shadow-none rounded-lg" data-testid="area-summary-card">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => onNavigate?.("area")} data-testid="goto-area"
          className="flex items-center gap-2 group" title="Buka modul Area Pengelolaan">
          <Map className="h-4 w-4 text-violet-600" />
          <h3 className="text-base font-semibold text-slate-900 group-hover:text-violet-600 transition-colors">Area Pengelolaan</h3>
          <ArrowRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-violet-600 group-hover:translate-x-0.5 transition-all" />
        </button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {[
          { icon: LandPlot, label: "Luas Indoor", value: fmtLuas(areaStats?.total_luas_indoor), tone: "text-blue-600 bg-blue-50" },
          { icon: Trees, label: "Luas Outdoor", value: fmtLuas(areaStats?.total_luas_outdoor), tone: "text-emerald-600 bg-emerald-50" },
          { icon: Map, label: "Kawasan", value: areaStats?.jumlah_kawasan ?? 0, tone: "text-violet-600 bg-violet-50" },
          { icon: Building2, label: "Gedung", value: areaStats?.jumlah_gedung ?? 0, tone: "text-amber-600 bg-amber-50" },
          { icon: Home, label: "Rumah Dinas", value: areaStats?.jumlah_rumah_dinas ?? 0, tone: "text-rose-600 bg-rose-50" },
        ].map((s, i) => (
          <div key={s.label} className="rounded-xl border border-slate-100 bg-slate-50/60 p-4 flex items-center gap-4"
            data-testid={`area-summary-item-${i}`}>
            <div className={`h-12 w-12 rounded-xl flex items-center justify-center shrink-0 ${s.tone}`}>
              <s.icon className="h-6 w-6" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{s.label}</p>
              <p className="text-2xl font-black text-slate-900 truncate">{s.value}</p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
